import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {clearCheckboxTires, setClearCheckboxSnackbar} from "../../core/redux/ActionCreator";
import "./CompareButtonBottom.scss";
import Button from "@material-ui/core/Button";

const CompareButtonBottom=()=>{
    const history = useHistory();
    const dispatch = useDispatch();
    const [toCompare, setToCompare] = useState(false);
    const [disableButton, setDisableButton] = useState(false);
    const selected = useSelector(state => state.searchResultReducer.checkboxes);

    useEffect(() => {
        if(selected.length > 1 && selected.length <= 3){
            setToCompare(true);
        }
    }, [selected]);

    //used to disable compare button
    useEffect(()=> {
        if (selected.length === 0 || selected.length > 3) {
            setDisableButton(true);
        }
    }, [selected.length]);


    function compareButton() {
        if (toCompare){
            history.push('/compareTires');
        }
    }

    function handleClearSelection() {
        dispatch(clearCheckboxTires(true));
        dispatch(setClearCheckboxSnackbar({snackbar: true}));
    }

    return (
        <div className={"buttonStyleBottom"}>
                <div className={'hide-on-desktop'}>
                    <div className={'clearSelectionPlacement'} style={{display: 'flex', justifyContent: 'center'}}>
                        <div className={"tireBrand stat-button-link"}
                             onClick={handleClearSelection}
                             color="primary"
                             data-dtm={'search results'}
                             style={{cursor: 'pointer', textAlign: 'right', marginRight: '26px'}}>
                            <u>Clear</u>
                        </div>
                    </div>

                    <div className={"tireErrorMessage"} hidden={selected.length < 3} style={{marginRight:"30px"}}>
                        You have selected too many tires, please choose 2
                    </div>
                    <div className={'buttonPlacementMobile'} style={{display: 'flex', justifyContent: 'center',
                        paddingRight: '25px'}}>
                        <Button classes={{root: "button primary-button stat-button-link", disabled: disableButton}} data-dtm={'search results'}
                                disabled={selected.length === 1 || selected.length > 2}
                                onClick={()=>compareButton()}
                                style={{alignSelf:"center", maxWidth: "90%"}}>
                            Compare {selected.length>1?selected.length:null} Tires
                        </Button>
                    </div>
                    <br/>
                </div>
                <div className={'hide-on-mobile'}>
                    <div className={"tireBrand stat-button-link"}
                         onClick={handleClearSelection}
                         color="primary"
                         data-dtm={'search results'}
                         style={{cursor: 'pointer', textAlign: 'right'}}>
                        <u>Clear</u>
                    </div>
                    <div className={"tireBrand"} style={{textAlign:"center", color:"red"}}>
                        <span hidden={selected.length < 4}>You have selected too many tires, please choose 3</span>
                    </div>
                    <div aria-disabled={disableButton} className={'buttonPlacement'}>
                        <Button classes={{root: "button primary-button stat-button-link", disabled: disableButton}} data-dtm={'search results'}
                                disabled={selected.length === 1 || selected.length > 3}
                                onClick={() => compareButton()}>Compare {selected.length > 1 ? selected.length : null} Tires
                        </Button>
                    </div>
                    <br/>
                </div>
        </div>
    )
}

export default CompareButtonBottom;
